// extracted by mini-css-extract-plugin
export default {"NewJobworkListPage":"NewJobworkListPage_NewJobworkListPage__WoF4Z"};